<template>
    <div class="h5 h-100">

        <!-- Mobile back button -->
        <div v-if="showBackButton" class="dn-m dn-l bb b--light-gray cf">
            <BackLink class="pv3 ph3 dib fl" @click="$emit('backClick')">Back to Menu</BackLink>
            <div class="bt b--light-gray"></div>
        </div>

        <LoginCore @forgotClick="$emit('forgotClick')" />

        <div class="tc">
            <div class="mt4">Don't have an account?</div>
            <a class="link yellow pointer" @click="$emit('signUpClick')"><h5 class="mt1 mb3 grow">Sign Up for Free</h5></a>
        </div>

    </div>
</template>

<script>
import BackLink from '@/components/controls/BackLink.vue';
import LoginCore from '@/components/global/LoginCore.vue';

export default {
    components: {
        BackLink,
        LoginCore
    },
    props: {
        showBackButton: {
            type: Boolean,
            default: true
        }
    }
};
</script>
